module.exports = __webpack_public_path__ + "img/talents4.035692fb.png";